import { useApplicationData } from '@provider';

export const useContactDetailsSummary = () => {
  const ContactDetails = useApplicationData('ContactDetails');

  return [
    {
      title: '',
      items: [
        {
          label: 'Email',
          value: ContactDetails?.email || '',
        },
        {
          label: 'Mobile',
          value: ContactDetails?.mobile || '',
        },
      ],
    },
  ];
};
